





import Vue from 'vue'

export default Vue.extend({
  name: 'ConfirmationAbsencesCellRenderer',

  computed: {
    icon (): string {
      // @ts-ignore
      if (this.params.data.medicalCertificate) {
        return 'check'
      } else {
        return 'clear'
      }
    },

    color (): string {
      // @ts-ignore
      if (this.params.data.medicalCertificate) {
        return 'green'
      } else {
        return 'red'
      }
    }
  }
})
